import { type RPPDomain } from '@retailer-platform/dashboard/core'
import { NavEntryPoint } from '@retailer-platform/dashboard/routing'
import { fulfillmentSettingsRouter } from './routing/fulfillmentSettingsRouter'
import { type DomainMessages } from './utils/domain/intl'
import { routes } from './routing/routes'
import EN_US from './translations/en-US.json'
import { type DomainAccessControlConfig } from './utils/domain/accessControl'
import { fulfillmentConfigurationsPageAccessControl } from './access-control/fulfillmentConfigurationsPageAccess.configuration'

const definition: RPPDomain<typeof routes, DomainMessages, DomainAccessControlConfig> = {
  id: 'fulfillment-settings',
  totem: {
    tool: 'fulfillment-settings-dashboard-tool',
  },
  routes,
  translations: { EN_US },
  lazyTranslations: {
    // Uncomment to lazy load your domain's foreign dictionaries
    // ES_ES: () => import('./translations/es-ES.json'),
    // FR_FR: () => import('./translations/fr-FR.json'),
  },
  routers: {
    scoped: [fulfillmentSettingsRouter],
  },
  navigationEntries: [
    {
      attachToV2: NavEntryPoint.OperationsGeneral,
      subNavItems: [
        {
          type: 'item',
          llmDescription:
            'Configure fulfillment settings including routing rules and delivery service providers',
          labelId: 'fulfillmentSettingsDomain.fulfillmentConfigurationsPage.title',
          route: 'fulfillment-settings-fulfillment-configurations',
          position: 10,
          positionNavV2: 10,
          accessControl: fulfillmentConfigurationsPageAccessControl,
        },
      ],
    },
  ],
  adminNavigationEntries: [],
}

export default definition
